// @/utils/WorkerWrapper.ts
// Worker Class
export class WorkerWrapper {
  private worker: Worker
  private messageQueue: {
    resolve: (value: any) => void
    id: string
  }[] = []

  constructor(workerScript) {
    this.worker = new Worker(workerScript)
    this.worker.onmessage = (event) => {
      const { id, result } = event.data
      const message = this.messageQueue.find((m) => m.id === id)
      if (message) {
        message.resolve(result) // 解析结果
        this.messageQueue = this.messageQueue.filter((m) => m.id !== id)
      }
    }
  }

  public postMessage(message: any): Promise<any> {
    return new Promise((resolve) => {
      const id = message.id
      this.messageQueue.push({ resolve, id })
      this.worker.postMessage(message)
    })
  }

  public clearTimer(id: string) {
    this.worker.postMessage({ id, action: 'clear' })
  }

  public terminate() {
    this.worker.terminate()
  }
}
